import {
  SET_DESTINATIONS_VIEW,
  SET_SELECTED_DESTINATION,
  SET_SELECTED_DESTINATIONS,
  DestinationsViewTypes,
  SetDestinationsViewPayload,
} from "./actions";

// This will determine whether the Destinations list is diplayed or not.
const initialState = {
  showDestinations: false,
  selectedDestination: "",
  selectedDestinations: [],
  openCount: 0,
};

const DestinationsReducer = (
  state = initialState,
  action: DestinationsViewTypes
) => {
  switch (action.type) {
    case SET_DESTINATIONS_VIEW: {
      const payload = action.payload as SetDestinationsViewPayload;
      return {
        ...state,
        showDestinations: payload?.show,
        openCount: state.openCount + 1,
      };
    }
    case SET_SELECTED_DESTINATION:
      return { ...state, selectedDestination: action.payload };
    case SET_SELECTED_DESTINATIONS:
      return {
        ...state,
        selectedDestination: action.payload,
        selectedDestinations: !state.selectedDestinations.includes(
          // Only  add the selected thumbnail if it isn't part of the list
          action.payload
        )
          ? [...state.selectedDestinations, action.payload]
          : [...state.selectedDestinations],
      };
    default:
      return state;
  }
};

export default DestinationsReducer;
